import { OrderItemDescriptor } from "entities/Order";

export function sortByReservedUntil(data: OrderItemDescriptor[]) {
  return data.sort((a, b) => a.reservedUntil! < b.reservedUntil! ? -1 : a.reservedUntil! > b.reservedUntil! ? 1 : 0)
}